<template>
    <!-- <button :id="computed_id"
        type="button"
        tabindex="0" 
        class="btn btn-light btn-lg py-0 px-1 help-button"
        data-toggle="popover"
        data-html="true" 
        :data-content="dataContent">
        <i :class="'fas fa-info-circle pt-1' + (active ? ' help-active' : '')"></i>
    </button> -->
    <div>    
        <button 
            :id="computed_id"
            type="button"
            class="btn btn-light btn-lg py-0 px-1 help-button"
            data-toggle="popover"
            title="Sistema de ayuda"
            data-html="true"
            :data-content="computed_content">
            <i :class="'fas fa-info-circle pt-1' + (active ? ' help-active' : '')"></i>
        </button>

    </div>
    <!-- <a 
        tabindex="0" 
        type="button" 
        class="btn btn-lg btn-light p-1" 
        data-html="true" 
        data-toggle="popover" 
        data-trigger="focus"
        data-content="<div class='p-3 help-body'>Haz clic aqui para activar o desactivar el sistema de ayuda<a href='/prospectos'>Prospectos</a></div>">
        <i class="fas fa-info-circle pt-1" style="font-size: 1.6em;"></i>      
    </a> -->
</template>

<script>
export default {
    props: [
        'id',
        'content',
        'title',
        'description',
        'videoUrl',
        'videoTitle',
        'pdfUrl',
        'pdfTitle',
    ],
    data() { return {
        active: false,
        dataContent: "<div class='p-3 help-body'><p>Busqueda de prospectos</p><a class='btn btn-light btn-sm btn-block'>Video tutorial</a></div>",
    }},
    computed: {
        computed_id() {
            if(this.id == undefined) {
                return ('help-button-' + this._uid);
            } else {
                return this.id;
            }
        },
        computed_content() {
            let html = '';
            let internalID = '';

            if(this.id == undefined) {
                internalID = ('help-button-' + this._uid);
            } else {
                internalID = this.id;
            }

            if(this.description != undefined) {
                this.html = '<p class="p-0">'+this.description+'</p>';
            }

            if(this.videoUrl != undefined) {
                this.html = this.html
                    +'<a class="btn btn-light btn-sm btn-block" id="'+internalID+'-video'+'">'
                        +'<i class="fab fa-youtube mr-2 text-danger"></i>'
                        +(this.videoTitle ? this.videoTitle : 'Video tutorial')
                    +'</a>';
            }

            if(this.pdfUrl != undefined) {
                this.html = this.html
                    +'<a class="btn btn-light btn-sm btn-block">'
                        +'<i class="fas fa-file-pdf mr-2 text-info"></i>'
                        +(this.pdfTitle ? this.pdfTitle : 'Documentación')
                    +'</a>';
            }

            html    = '<div class="p-3 help-body">'
                    + this.html
                    + '</div>';

            return html;

            /* if(this.content == undefined) {
                return "<div class='p-3 help-body'>Haz clic aqui para activar o desactivar el sistema de ayuda</div>";
            } else {
                return "<div class='p-3 help-body'>"+this.content+"</div>";
            } */
        }
    },
    mounted() {
        const vm = this;
        const HelpButton = $('#'+vm.computed_id);
        
        const VideoButton = $('#'+vm.computed_id+'-video');
        console.log('#'+vm.computed_id+'-video');

        /* HelpButton.hover(function() {
            HelpButton.popover('show');
        }, function() {
            HelpButton.popover('hide');
        }); */
        
        HelpButton.click(function () {

            /* if(vm.active) {
                vm.dataContent = "<div><button type='button' class='btn btn-info btn-sm'>Video tutorial</button></div>";
                HelpButton.data('popover').setContent();
            } else {
                vm.dataContent = "<div class='p-3 help-body'>Haz clic aqui para activar o desactivar el sistema de ayuda</div>";
                HelpButton.data('popover').setContent();
            }
            vm.active = !vm.active; */
            vm.active = !vm.active;
        });

        setTimeout(() => {
            $('#'+vm.computed_id+'-video').click(function() {
                console.log('si video');
            });
        }, 2000);
    }
}
</script>